"use client";

import { usePathname } from "next/navigation";

export default function FooterWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const hiddenRoutes = new Set(["/client-assessment/result", "/login"]);

  const hiddenPrefixes = ["/portfolio-services/", "/financial-planning/retirement-planning/", "/financial-planning/child-future-planning/"];

  const shouldHide = hiddenRoutes.has(pathname) || hiddenPrefixes.some((prefix) => pathname.startsWith(prefix));

  if (shouldHide) return null;

  return <>{children}</>;
}
